var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-creator-preview",class:{
      portrait: _vm.isPortrait,
      //landscapeSidebar: isLandscapeSidebar
    }},[(_vm.loading)?_c('Loader'):_c('div',{staticClass:"content-creator-preview-wrap"},[_c('div',{staticClass:"content-creator-preview-main",domProps:{"innerHTML":_vm._s(_vm.html)}})]),(_vm.currentContent?.sectionCss)?_c('div',{staticClass:"content-creator-preview-styles"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentContent?.sectionCss)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }